import api, { CODIGOS_IR_A_LOGIN, irAlLogin } from "@/api/axios"

function esperar(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

// Polling genérico de /job/:jobId — usado por búsqueda/cotización
// automática (useVuelos.js) y por el Cotizador Manual.
export async function esperarJob(jobId, intervalo = 4000) {
    for (;;) {
        let job

        try {
            const { data } = await api.get(`/job/${jobId}`)
            job = data.job
        } catch (err) {
            if (err.response?.status === 404) {
                throw new Error("El proceso expiró o no existe")
            }
            await esperar(intervalo)
            continue
        }

        if (job.status === "done") return job.resultado
        if (job.status === "error") {
            // Búsqueda expirada o sesión revocada/inválida en el worker:
            // reintentar no sirve, se manda al login
            if (CODIGOS_IR_A_LOGIN.includes(job.code) || job.code === "TOKEN_EXPIRED") irAlLogin()
            throw new Error(job.error || "Error en el proceso")
        }

        await esperar(intervalo)
    }
}
